// extracted by mini-css-extract-plugin
export var container = "CruiseItineraryItemDetails-module--container--f9d83";
export var noExcursions = "CruiseItineraryItemDetails-module--no-excursions--dd641";
export var title = "CruiseItineraryItemDetails-module--title--a8eb7";
export var wrapper = "CruiseItineraryItemDetails-module--wrapper--3f290";